// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width: number;
    height: number;
}

const IPFilteringEarthSvg = ({width, height}: SvgProps) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 132 90'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect
            y='25'
            width='132'
            height='41'
            rx='3.75'
            fill='#3F4350'
            fillOpacity='0.08'
        />
        <circle
            cx='6.5'
            cy='14'
            r='2'
            transform='rotate(-90 6.5 14)'
            fill='#3F4350'
            fillOpacity='0.32'
        />
        <circle
            cx='6.5'
            cy='8'
            r='2'
            transform='rotate(-90 6.5 8)'
            fill='#3F4350'
            fillOpacity='0.32'
        />
        <circle
            cx='6.50049'
            cy='2'
            r='2'
            transform='rotate(-90 6.50049 2)'
            fill='#3F4350'
            fillOpacity='0.32'
        />
        <path
            d='M6.5 18.5V58.5H29M31 58.5H35M37 58.5H39'
            stroke='#3F4350'
            strokeOpacity='0.32'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <circle
            cx='66.7162'
            cy='44.7162'
            r='40.2162'
            fill='white'
            stroke='#3F4350'
        />
        <circle
            cx='68'
            cy='46'
            r='38'
            fill='#1C58D9'
            fillOpacity='0.08'
        />
        <path
            d='M68.9197 17.4431C71.4887 18.2645 71.3834 16.6428 73.0049 18.5313C73.9385 19.6194 75.6231 21.5991 77.6236 22.0905C77.9044 22.1607 78.5291 21.557 78.5291 21.0796C78.5291 20.6022 77.1252 19.5913 76.3531 19.3807C75.581 19.1701 76.6689 17.6818 75.609 17.2255C74.5491 16.7692 73.3769 15.0773 72.9558 13.7505C72.5346 12.4237 70.6675 13.5399 70.0287 13.2732C69.39 13.0064 68.6249 13.1679 67.9229 14.1788C67.221 15.1897 68.2598 17.2325 68.9197 17.4431Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M82.832 54.5925C82.832 54.0379 77.75 51.272 77.1324 51.2369C76.1216 51.1737 74.7458 50.6682 73.8192 51.2369C73.4279 51.459 73.0956 51.772 72.8506 52.1495C72.6751 52.4794 71.6854 51.8687 71.3063 52.0723C70.3938 52.5567 69.9024 50.9771 70.1341 50.3734C70.7728 48.8921 68.5196 49.8258 68.288 49.4186C68.5618 49.903 68.2108 45.2065 67.4246 47.8531C66.828 49.8609 64.4906 47.5653 64.7714 46.1051C65.2066 43.8516 68.6039 43.5217 69.3479 43.9218C69.727 44.1254 71.1098 46.1262 71.2853 46.07C71.6643 45.9507 71.0606 43.7112 70.9834 43.4164C70.7167 42.3212 72.8085 41.9562 72.9559 40.8119C73.0822 39.8431 73.742 40.1801 74.3597 39.6676C75.3073 38.9164 74.5633 37.5124 75.7636 36.7963C76.1777 36.5506 77.729 36.3751 77.9326 35.9399C78.1361 35.5046 76.627 34.4586 77.9326 34.1497C79.0837 33.8689 80.2559 34.3673 80.5718 32.7036C80.8526 31.1942 79.1679 30.8502 78.6836 29.6779C78.5292 29.3269 78.3397 27.305 77.6237 27.6771C76.7463 28.1404 76.2199 29.2567 75.4758 27.9298C74.1772 25.536 70.9624 24.504 72.4715 28.2668C73.2436 30.2114 70.3657 36.1294 69.9235 30.6607C69.7761 28.7582 64.0905 28.1896 65.9997 26.0835C67.909 23.9775 70.5833 23.8792 71.2993 20.6008C72.2961 16.0517 69.1444 19.8987 67.5369 19.0423C65.1363 17.7295 67.1719 18.4385 65.9295 20.1374C65.4592 20.7833 63.915 19.7303 63.2271 19.8356C62.5392 19.9409 60.9598 21.3379 60.5176 20.4604C59.7174 18.8527 54.081 17.8629 52.5578 18.4315C49.378 19.625 48.276 18.0103 45.1033 17.3855C44.0012 17.1679 38.5893 17.0134 38.9403 18.8878C39.1931 19.5748 39.4885 20.2454 39.8247 20.8956C40.1687 21.9276 38.6174 21.1343 38.2595 21.38C38.8914 21.9405 39.5521 22.4677 40.2389 22.9595C40.7583 23.4931 38.2524 24.1389 37.9997 25.0235C37.5014 26.8206 41.4462 26.3082 40.7232 28.4704C40.4986 29.1233 38.2454 30.1974 38.0278 32.4087C37.9857 32.8299 40.8355 29.6709 42.6746 30.3027C44.296 30.8924 44.1557 26.4837 46.1842 26.4837C49.9466 26.4837 50.6766 30.1482 52.656 32.6053C53.5826 33.7496 54.3266 34.227 54.4951 35.7223C54.6636 37.2176 54.3477 38.8111 54.8531 40.1379C55.3585 41.4648 56.3131 41.4928 56.9589 42.5178C57.731 43.7182 58.1662 44.8906 59.2121 45.9366C60.7282 47.46 63.3113 49.7907 65.6979 49.4467C66.1682 49.3765 67.9441 50.3874 68.3442 50.6893C68.8985 51.2103 69.3717 51.8113 69.748 52.4724C70.1692 53.034 71.5029 52.683 72.0855 52.9498C72.6681 53.2165 70.7308 57.1619 71.4327 58.1728C72.1346 59.1837 72.1978 60.5948 73.3419 61.4934C74.4861 62.3919 74.7458 62.413 74.8932 63.8943C75.1108 66.2952 74.4089 68.7241 73.8333 70.9636C73.5314 72.1079 74.1351 73.3785 73.6858 74.4737C73.1243 75.8426 72.7453 77.022 73.2366 78.5454C74.086 81.192 78.8521 81.6202 76.0444 79.3106C74.8441 78.3278 77.3429 75.9549 76.5638 75.7303C75.2231 75.1687 76.8094 74.6632 76.9849 74.0806C77.3429 72.9222 82.6565 68.1274 83.0496 67.3342C83.3795 66.6672 83.1689 65.9793 83.7094 65.4036C84.2499 64.828 85.1133 64.9894 85.8152 64.5401C87.2191 63.5994 86.7137 62.0058 87.2963 60.7071C88.4474 58.1307 88.9318 59.1486 87.3525 57.1338C86.7558 56.4037 82.9373 56.6705 82.832 54.5925Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M54.4039 15.6117C55.3726 16.6226 56.3342 15.0852 56.5097 15.6117C56.6852 16.1382 56.6992 17.1491 57.8504 17.2263C59.0015 17.3036 56.7764 18.0547 57.5205 18.3706C58.2645 18.6865 59.8579 19.6974 60.4405 19.2762C61.0231 18.855 61.718 18.5321 61.9777 18.848C62.2374 19.1639 63.8378 18.7989 63.3816 18.2653C62.9253 17.7318 61.711 16.4752 61.7601 15.7521C61.8092 15.029 63.164 13.1687 61.6549 13.3301C61.2907 13.3759 60.959 13.5624 60.7307 13.8498C60.5025 14.1371 60.3957 14.5025 60.4335 14.8675C60.4335 15.4011 59.0296 14.0743 58.7348 14.0953C58.44 14.1164 57.4573 12.4807 57.0853 12.4807C56.7133 12.4807 54.2214 11.6804 54.432 12.4807C54.6425 13.281 53.4352 14.6008 54.4039 15.6117Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M76.6831 23.2076C75.932 22.7794 74.5071 20.8207 73.8754 21.4525C73.2436 22.0844 74.0368 23.5586 74.5773 24.1623C75.1178 24.7661 77.3429 26.1842 77.02 25.5664C76.6971 24.9486 78.1571 24.057 76.6831 23.2076Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M55.8707 9.6992C56.2567 9.66409 56.8604 11.005 57.429 11.1524C57.9975 11.2998 58.2783 11.9667 58.4889 12.1211C58.6995 12.2756 61.079 11.363 61.6406 11.1524C62.2021 10.9418 60.9386 9.62899 60.4683 8.70935C59.9981 7.7897 60.363 10.2327 59.6962 9.83258C59.0294 9.43243 59.1276 8.88485 58.2923 8.88485C57.457 8.88485 58.0396 7.22107 57.0148 7.57208C55.99 7.92309 55.4846 9.7343 55.8707 9.6992Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M64.4061 12.887C63.7042 13.0274 63.8376 13.4837 63.4445 13.8769C63.261 14.0645 63.1582 14.3165 63.1582 14.5789C63.1582 14.8413 63.261 15.0933 63.4445 15.2809C63.8025 15.7372 64.364 16.5516 64.7922 15.7723C65.2203 14.9931 64.7922 14.3683 64.7922 13.8628C64.7922 13.3574 64.7501 12.8168 64.4061 12.887Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M65.8175 15.3641C65.993 15.7853 66.3159 14.6199 67.0038 14.0162C67.6917 13.4125 66.6668 11.9101 66.0281 12.6753C65.5999 13.2019 65.642 14.9359 65.8175 15.3641Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M65.6908 15.8909C65.3258 16.4103 65.031 17.8003 65.6908 17.9126C65.8353 17.9293 65.9816 17.9056 66.1135 17.8441C66.2453 17.7825 66.3575 17.6856 66.4375 17.5641C66.5176 17.4426 66.5623 17.3012 66.5668 17.1558C66.5713 17.0103 66.5353 16.8665 66.4629 16.7403C66.154 16.2138 65.8452 15.6802 65.6908 15.8909Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M68.3649 6.93293C67.7332 7.22076 69.2915 7.74728 68.2246 8.0351C67.1576 8.32293 67.1295 9.20044 66.21 8.4563C65.2905 7.71216 64.2867 8.70903 64.9816 9.15832C65.6765 9.60761 66.8417 10.7168 66.8066 11.3205C66.7715 11.9243 67.9087 12.2051 68.9686 12.1349C70.0285 12.0647 71.306 12.3806 71.3411 11.9243C71.3762 11.468 71.5026 11.2714 71.3762 10.9274C71.1937 10.429 70.7374 9.93756 69.6424 10.3658C68.5474 10.794 67.8314 10.5764 67.677 10.0429C67.5226 9.50933 69.8249 8.48439 70.8427 9.19343C71.8605 9.90247 72.8292 8.80731 72.0852 8.30888C71.3411 7.81045 71.8395 7.28394 72.3519 7.21373C72.7239 7.16459 73.0538 6.22388 73.3346 5.49378C71.7733 5.24122 70.1981 5.08416 68.6176 5.02344C68.6246 6.02732 68.9967 6.6451 68.3649 6.93293Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M58.9521 6.04835C59.654 6.35022 60.8193 6.04836 60.6017 5.50781C59.9629 5.62013 59.3241 5.73947 58.6924 5.87285C58.7626 5.95248 58.852 6.01288 58.9521 6.04835Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M59.3875 6.64593C58.3908 6.13346 58.4469 7.39006 58.9032 7.8885C59.3594 8.38693 60.6791 7.27775 59.3875 6.64593Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M65.4521 5.02369C65.7584 5.07898 66.0448 5.21381 66.2825 5.41464C66.5203 5.61547 66.7011 5.87526 66.8069 6.16799C66.9402 6.61728 68.0142 5.64147 68.0282 5.00263H67.0034C66.484 4.99561 65.9716 5.00263 65.4521 5.02369Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M63.3459 6.49694C62.8967 7.11471 63.2827 7.85885 63.8162 7.24107C64.3497 6.6233 63.9215 5.0578 64.3426 5.73174C64.7638 6.40568 65.55 7.47273 66.0764 7.52188C66.6029 7.57102 66.1466 6.89708 66.0764 6.33546C66.0062 5.77385 64.7498 5.24033 64.8902 5.05078C64.104 5.0929 63.3249 5.15608 62.5527 5.24032C63.1073 5.60537 63.6899 6.05466 63.3459 6.49694Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M65.6909 11.8195C66.3156 12.0722 65.6909 10.5488 65.6909 10.5488C65.0381 10.9349 65.0732 11.5597 65.6909 11.8195Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M63.4448 10.8579C63.5501 11.2861 64.224 11.4265 64.5819 10.8579C64.9399 10.2893 64.5819 8.22532 64.0765 8.8782C63.5711 9.53107 62.9885 9.2292 61.9707 8.8782C60.9529 8.52719 63.3466 10.4086 63.4448 10.8579Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M70.3657 47.0246C71.2361 46.9193 71.7696 47.9793 72.7523 47.9302C73.735 47.881 75.2231 49.3693 76.0724 48.4848C76.7744 47.7827 73.0401 47.186 71.8609 46.5472C70.6816 45.9084 69.5024 47.1299 70.3657 47.0246Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M74.7036 7.10827C75.925 7.69796 75.7144 7.6769 74.9703 8.24553C74.2263 8.81417 74.493 10.0497 76.1355 9.96549C77.778 9.88125 78.7959 8.24553 79.5399 10.5482C80.2839 12.8508 79.7505 15.364 80.7051 16.073C81.6597 16.7821 80.8665 17.2595 80.7051 17.9194C80.5436 18.5792 80.9718 19.0566 81.7159 18.846C82.4599 18.6354 82.2493 20.0184 81.7159 20.6011C81.1824 21.1837 80.5507 22.2999 82.1932 24.3218C83.8357 26.3436 84.0533 26.0698 84.5798 26.7648C85.1062 27.4598 85.5414 26.505 85.6958 25.7047C85.8503 24.9044 85.3238 22.0893 87.212 22.0893C87.8001 22.083 88.3706 21.8879 88.8395 21.5327C89.3083 21.1775 89.6507 20.6812 89.8162 20.1167C90.0268 19.6393 91.5148 19.6884 92.308 19.0005C93.1012 18.3125 93.8031 17.8702 93.8242 15.4904C88.3687 10.4269 81.5866 7.01838 74.2684 5.66211C74.0929 6.20968 74.0999 6.82746 74.7036 7.10827Z'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M107.091 59L124 59L124 72'
            stroke='#3F4350'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M102.864 59L98.6365 59'
            stroke='#3F4350'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M95.8184 59L93.0002 59'
            stroke='#3F4350'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M58.6019 0.383106C66.948 -1.2328 75.0348 -0.505835 82.8517 2.566C86.0609 3.82715 89.2246 5.48354 92.3421 7.5353C96.241 10.3141 99.561 13.4221 102.301 16.8613M75.1367 88.7753C65.3658 90.5265 55.9902 89.2627 47.0305 84.9538C45.1531 84.0509 43.2939 83.0144 41.4532 81.8438C36.5678 78.2399 32.595 74.1786 29.5312 69.6573M22.6732 52.8466C21.5895 47.0125 21.6254 41.2894 22.7809 35.6774C23.9485 30.0062 26.2594 24.4483 29.7137 19.0039M107.617 25.4379C109.192 28.8187 110.342 32.443 111.065 36.3118C111.935 40.9918 112.097 45.5669 111.552 50.0365M105.118 20.8383C105.559 21.5417 105.978 22.2572 106.376 22.9848'
            stroke='#3F4350'
            strokeOpacity='0.48'
        />
    </svg>

);

export default IPFilteringEarthSvg;
